module.exports = __webpack_public_path__ + "img/1-l.d8653236.png";